


























































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import BpcHeaderSearchBox from '@shared/layouts/components/header/header-search-box.vue';
import BpcHeaderUserArea from '@shared/layouts/components/header/header-user-area.vue';
import BpcHeaderNotificationArea from '@shared/layouts/components/header/header-notification-area.vue';
import BpcHeaderCalendarArea from '@shared/layouts/components/header/header-calendar-area.vue';
import BpcHeaderShoppingCartArea from '@shared/layouts/components/header/header-shopping-cart-area.vue';
import BpcHeaderLanguageSelector from '@shared/layouts/components/header/header-language-selector.vue';
import BpcHeaderPosSessionArea from '@shared/layouts/components/header/header-pos-session-area.vue';
import BpcHeaderPosSessionCreation from '@shared/layouts/components/header/header-pos-session-creation.vue';
import BpcHeaderTenantsSelector from '@shared/layouts/components/header/header-tenants-selector.vue';
import BpcHeaderAdminPublicSwitch from '@shared/layouts/components/header/header-admin-public-switch.vue';
import BpcHeaderHelpdeskLink from '@shared/layouts/components/header/header-helpdesk-link.vue';
import ModulesHelper from '@core/services/modules.helper';

library.add(faEllipsisV);

@Component({
  name: 'bpc-header',
  components: {
    BpcHeaderSearchBox,
    BpcHeaderUserArea,
    BpcHeaderNotificationArea,
    BpcHeaderCalendarArea,
    BpcHeaderShoppingCartArea,
    'font-awesome-icon': FontAwesomeIcon,
    BpcHeaderLanguageSelector,
    BpcHeaderPosSessionArea,
    BpcHeaderTenantsSelector,
    BpcHeaderAdminPublicSwitch,
    BpcHeaderHelpdeskLink,
    BpcHeaderPosSessionCreation,
  },
})
export default class Header extends Vue {
  @Prop({ type: String, default: 'public' }) readonly layout: string;

  public isOpen: boolean = false;
  public isOpenMobileMenu: boolean = false;

  get isAdminLayout(): boolean {
    return this.layout == 'admin';
  }
  get isPOSLayout(): boolean {
    return this.layout == 'pos';
  }
  get isPublicLayout(): boolean {
    return this.layout == 'public';
  }

  get isLoggedIn(): boolean {
    return this.$authService.isLoggedIn();
  }

  get isRoleContact() {
    return (
      this.$authorizationService.hasRole('contact') ||
      this.$authorizationService.hasRole('contact_read')
    );
  }

  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get tenantName() {
    return this.$store.getters['centerSettings/centerSettings']
      ? this.$store.getters['centerSettings/centerSettings'].name
      : null;
  }

  get contactType(): string {
    return this.$store.getters['auth/profile']({ tenantId: this.tenantId })?.contact_type || null;
  }

  get showMenuEntries(): string[] {
    if (!this.contactType) {
      return [];
    } else if (this.contactType === 'individual') {
      return this.$store.getters['centerSettings/centerSettings']?.show_menu_entries || [];
    } else {
      return (
        this.$store.getters['centerSettings/centerSettings']?.show_menu_entries_for_organization ||
        []
      );
    }
  }

  get isShoppingCartActivated(): boolean {
    return this.$store.getters['centerSettings/shoppingCartActivated'];
  }

  get isShoppingCartInMenuEntries(): boolean {
    return this.showMenuEntries.includes('shopping-cart');
  }

  get canViewShoppingCartArea() {
    return (
      this.isPublicLayout &&
      this.isLoggedIn &&
      this.isShoppingCartActivated &&
      this.isShoppingCartInMenuEntries
    );
  }

  get isBookingsModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.BOOKINGS_MODULE_NAME);
  }

  get canViewCalendarArea(): boolean {
    return (this.isAdminLayout || this.isPOSLayout) && this.isBookingsModuleActivated;
  }

  get isCommunicationsModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.COMMUNICATIONS_MODULE_NAME);
  }

  get isNotificationInMenuEntries(): boolean {
    return this.showMenuEntries.includes('mailbox');
  }

  get canViewNotificationArea() {
    return (
      this.isLoggedIn &&
      this.isCommunicationsModuleActivated &&
      (this.isAdminLayout || this.isNotificationInMenuEntries)
    );
  }

  get allowAccessPublicWebpage() {
    return this.$store.getters['centerSettings/centerSettings']?.allow_access_public_website;
  }

  get allowAccessClientSection() {
    return this.$store.getters['centerSettings/centerSettings']?.allow_access_client_section;
  }

  get canViewAdminPublicSwitch(): boolean {
    return (
      this.isLoggedIn &&
      ((this.isAdminLayout && this.allowAccessPublicWebpage) ||
        (this.isPublicLayout && !this.isRoleContact) ||
        this.isPOSLayout)
    );
  }

  get isPOSModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.POS_MODULE_NAME);
  }

  get hasPosSessionOpened(): boolean {
    return !!this.$store.getters['pos/openPosSession'];
  }

  get canViewPosSessionOpened(): boolean {
    return this.$store.getters['pos/openPosSession']?.status === 'reopened'
      ? this.$authorizationService.hasPermission('reopen_pos_sessions')
      : true;
  }

  get canViewHelpdeskLink(): boolean {
    return this.isLoggedIn && !this.isRoleContact;
  }

  get canViewPOSSessionArea(): boolean {
    return (
      this.isAdminLayout &&
      this.isPOSModuleActivated &&
      this.hasPosSessionOpened &&
      this.canViewPosSessionOpened
    );
  }
  get canViewPOSSessionCreationButton(): boolean {
    return (
      this.$authorizationService.hasPermission('manage_pos_sessions') &&
      this.isAdminLayout &&
      this.isPOSModuleActivated &&
      !this.hasPosSessionOpened
    );
  }

  get canViewLanguageSelector(): boolean {
    return !this.isPOSLayout;
  }

  get env(): string {
    const api_domain = process.env.VUE_APP_API_DOMAIN.split('.');
    if (api_domain && api_domain[1]) {
      if (['dev', 'tst', 'trial', 'demo'].includes(api_domain[1])) {
        return api_domain[1];
      } else if (api_domain[1] !== 'big-captain') {
        return 'unknown';
      }
    }
    return '';
  }

  get envVariant(): string {
    if (this.env) {
      if (this.env === 'dev') {
        return 'warning';
      } else if (this.env === 'tst') {
        return 'warning';
      } else if (this.env === 'demo') {
        return 'info';
      } else if (this.env === 'trial') {
        return 'danger';
      } else if (this.env === 'unknown') {
        return 'warning';
      } else {
        return '';
      }
    }
    return '';
  }

  // TODO Remove?
  showBookingForm() {
    this.$root.$emit('showBookingForm', 1);
  }

  public toggleBodyClass(className) {
    const el = document.body;
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      el.classList.add(className);
    } else {
      el.classList.remove(className);
    }
  }

  public toggleMobile(className) {
    const el = document.body;
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      el.classList.add(className);
    } else {
      el.classList.remove(className);
    }
  }
}
